/*!
 * Copyright (c) 2018 Digital Bazaar, Inc. All rights reserved.
 */
'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports = /*#__PURE__*/function () {
  function LinkedDataProof() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        type = _ref.type;

    _classCallCheck(this, LinkedDataProof);

    if (typeof type !== 'string') {
      throw new TypeError('A LinkedDataProof must have a "type".');
    }

    this.type = type;
  }
  /**
   * @param document {object} to be signed.
   * @param purpose {ProofPurpose}
   * @param documentLoader {function}
   * @param expansionMap {function}
   * @param compactProof {boolean}
   *
   * @returns {Promise<object>} Resolves with the created proof object.
   */


  _createClass(LinkedDataProof, [{
    key: "createProof",
    value: function () {
      var _createProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var document, purpose, documentLoader, expansionMap, compactProof;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                document = _ref2.document, purpose = _ref2.purpose, documentLoader = _ref2.documentLoader, expansionMap = _ref2.expansionMap, compactProof = _ref2.compactProof;
                throw new Error('"createProof" must be implemented in a derived class.');

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function createProof(_x) {
        return _createProof.apply(this, arguments);
      }

      return createProof;
    }()
    /**
     * @param proof {object} the proof to be verified.
     * @param document {object} the document the proof applies to.
     * @param purpose {ProofPurpose}
     * @param documentLoader {function}
     * @param expansionMap {function}
     *
     * @returns {Promise<{object}>} Resolves with the verification result.
     */

  }, {
    key: "verifyProof",
    value: function () {
      var _verifyProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
        var proof, document, purpose, documentLoader, expansionMap;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                proof = _ref3.proof, document = _ref3.document, purpose = _ref3.purpose, documentLoader = _ref3.documentLoader, expansionMap = _ref3.expansionMap;
                throw new Error('"verifyProof" must be implemented in a derived class.');

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function verifyProof(_x2) {
        return _verifyProof.apply(this, arguments);
      }

      return verifyProof;
    }()
    /**
     * @param proof {object} the proof to be matched.
     * @param document {object} the document the proof applies to.
     * @param purpose {ProofPurpose}
     * @param documentLoader {function}
     * @param expansionMap {function}
     *
     * @returns {Promise<{boolean}>} Resolves with the verification result.
     */

  }, {
    key: "matchProof",
    value: function () {
      var _matchProof = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref4) {
        var proof, document, purpose, documentLoader, expansionMap;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                proof = _ref4.proof, document = _ref4.document, purpose = _ref4.purpose, documentLoader = _ref4.documentLoader, expansionMap = _ref4.expansionMap;
                return _context3.abrupt("return", proof.type === this.type);

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function matchProof(_x3) {
        return _matchProof.apply(this, arguments);
      }

      return matchProof;
    }()
  }]);

  return LinkedDataProof;
}();